import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'

import firebase from 'firebase/app'
import "firebase/auth"
import "firebase/firestore"

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@coreui/coreui/dist/css/coreui.min.css';

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

const firebaseConfig = {
  apiKey: "AIzaSyBwX3WZIWQ7C5zk7YEPZ-QIjTOR5-7VU2I",
  authDomain: "seelfa-206f0.firebaseapp.com",
  projectId: "seelfa-206f0",
  storageBucket: "seelfa-206f0.appspot.com",
  messagingSenderId: "830114116445",
  appId: "1:830114116445:web:01632a2e20ec7304ce6eb4",
  measurementId: "G-Y98ML9SLTJ"
};
//0730
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// firebase.analytics();

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
